export const isInteger = (value: string) => {
  // Check input represents integer number
  return /^\d*$/.test(value);
};
